var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 6.88333H12.6V6.98333C12.6 8.6759 12.0121 10.1207 10.8379 11.3119C9.66341 12.5033 8.23215 13.1 6.55 13.1C5.70363 13.1 4.90675 12.9391 4.16036 12.6168C3.41596 12.2954 2.76379 11.8579 2.20465 11.3044C1.64526 10.7507 1.20477 10.101 0.883193 9.35631C0.560887 8.60992 0.4 7.81303 0.4 6.96667C0.4 6.12031 0.560886 5.32877 0.883416 4.59318C1.20509 3.85954 1.64566 3.21829 2.20501 2.67024C2.76425 2.1223 3.41651 1.69043 4.16094 1.37461C4.9072 1.05802 5.70388 0.9 6.55 0.9C7.45405 0.9 8.31076 1.09789 9.11897 1.49352C9.84653 1.84967 10.4848 2.32527 11.0333 2.91987V1.41667V1.31667H11.1333H12.1333H12.2333V1.41667V4.88333V4.98333H12.1333H8.65H8.55V4.88333V3.88333V3.78333H8.65H10.1762C9.72873 3.3023 9.21305 2.90976 8.62879 2.60535C7.98215 2.26845 7.28969 2.1 6.55 2.1C5.18657 2.1 4.02261 2.56526 3.05261 3.49711C2.08346 4.42816 1.6 5.56596 1.6 6.91667C1.6 8.30189 2.07881 9.47649 3.03778 10.4464C3.99646 11.4159 5.16516 11.9 6.55 11.9C7.91245 11.9 9.05874 11.4216 9.99515 10.4634C10.9321 9.50468 11.4 8.34656 11.4 6.98333V6.88333H11.5H12.5Z",
    fill: "#73797E",
    stroke: "#73797E",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUndo);
export default __webpack_public_path__ + "static/media/icon-undo.d048eb69779f4a13a399786b2bf8bc2b.svg";
export { ForwardRef as ReactComponent };